<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <div class="footer">
      <a href="https://beian.miit.gov.cn" target="_blank">
        京ICP备2022005685号-1
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: '个人APP开发学习',
  data () {
    return {
      msg: '欢迎来到个人APP开发学习'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
a {
  color: #b97242;
}
.footer {
  position: fixed;
  bottom: 30px;
  right: 0;
  left: 0;
  margin-right: 0;
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue